module.exports = __webpack_public_path__ + "img/rules-setup.940118e6.jpg";